import { FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { authApi } from '../../api/auth';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [resetToken, setResetToken] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError('');
    try {
      const res = await authApi.requestPasswordReset(email);
      setMessage(res.message ?? 'If the email exists, a reset link was sent.');
      if (res.reset_token) setResetToken(res.reset_token);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Request failed');
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 p-4">
      <form onSubmit={onSubmit} className="w-full max-w-md rounded-xl border border-slate-200 bg-white p-8 shadow-sm">
        <h1 className="text-2xl font-semibold text-slate-900">Reset password</h1>
        {message && <p className="mt-4 rounded-lg bg-green-50 p-3 text-sm text-green-800">{message}</p>}
        {resetToken && <p className="mt-2 text-xs text-amber-800">Dev reset token: <code>{resetToken}</code></p>}
        {error && <p className="mt-4 rounded-lg bg-red-50 p-3 text-sm text-red-700">{error}</p>}
        <label className="mt-6 block text-sm font-medium text-slate-700">
          Email
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2" />
        </label>
        <button type="submit" className="mt-6 w-full rounded-lg bg-slate-900 px-4 py-2 text-white">Send reset link</button>
        <p className="mt-4 text-center text-sm"><Link to="/login" className="text-blue-600 hover:underline">Back to sign in</Link></p>
      </form>
    </div>
  );
}
